import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InvoiceserviceService {

  constructor(private apiService: ApiService, private http: HttpClient) { }
  getInvoices() {
    return this.apiService.get('invoices');
  }

  //   getInvoices(params: HttpParams) {
  //   return this.apiService.get("invoices", { params });
  // }
  getInvoiceById(id: number) {
    return this.apiService.get(`invoices/${id}`);
  }

  deleteInvoice(id: number, restoreStock: boolean = true) {
    const params = new HttpParams().set('restore_stock', restoreStock ? '1' : '0');
    return this.apiService.delete('invoices/' + id, {}, params);
  }

  getActiveUdhars() {
    return this.apiService.get('active-udhars');
  }
  getActiveUdharsbyCustomer(customerId: number) {
    return this.apiService.get(`customers/${customerId}/active-udhars`);
  }

  payUdhar(invoiceId: number, payload: any) {
    return this.apiService.post(`invoices/pay-udhar/` + invoiceId, payload);
  }
  /**
     * CORRECTED: Removed the curly braces around params.
     * Your ApiService wrapper likely expects the HttpParams object directly.
     */
  getTransactions(customerId: number, params: any) {
    return this.apiService.get(`user-transactions/${customerId}`, params);
  }

  getSaleReport(params: any) {
    return this.apiService.get('sale-report', params);
  }

}
